import { flatten, omit, values } from "lodash/fp";

import { EvalIds } from "graphql/generated";
import { evaluationLSName } from "src/constants/local-storage-names.constant";

export const getEvaluationDataFromLocalStorage = (evaluationId: EvalIds) => {
  const localEval = localStorage.getItem(evaluationLSName(evaluationId));

  if (localEval) {
    const currentLocalEval = JSON.parse(localEval);

    const isDone = currentLocalEval?.done;
    const evaluationSysId = currentLocalEval?.evaluationSysId;
    const consultType = currentLocalEval?.consultType;
    const latestQuestionSysId = currentLocalEval?.latestQuestionSysId;

    const evaluationData = flatten(
      values(
        omit(["done", "evaluationSysId", "latestQuestionSysId", "consultType"], currentLocalEval)
      )
    );
    const patientQAndA = evaluationData?.map(({ question, answer, value }) => ({
      questionAnswer: {
        question,
        answer
      },
      value: value?.toString()
    }));

    return {
      evaluationData,
      isDone,
      evaluationSysId,
      consultType,
      latestQuestionSysId,
      patientQAndA
    };
  }
  return { isDone: false };
};
